// Renders a single block based on its type.
import HeroBlock from "./types/HeroBlock";
import HeadingBlock from "./types/HeadingBlock";
import TextBlock from "./types/TextBlock";
import ImageBlock from "./types/ImageBlock";
import GalleryBlock from "./types/GalleryBlock";
import CtaBlock from "./types/CtaBlock";
import PlantCarouselBlock from "./types/PlantCarouselBlock";
import VideoBlock from "./types/VideoBlock";
import TourListBlock from "./types/TourListBlock";
import NewsletterBlock from "./types/NewsletterBlock";
import SpacerBlock from "./types/SpacerBlock";

const REGISTRY = {
  hero: HeroBlock,
  heading: HeadingBlock,
  text: TextBlock,
  image: ImageBlock,
  gallery: GalleryBlock,
  cta: CtaBlock,
  plant_carousel: PlantCarouselBlock,
  video: VideoBlock,
  tour_list: TourListBlock,
  newsletter: NewsletterBlock,
  spacer: SpacerBlock,
};

export default function BlockRenderer({ block }) {
  if (!block || !block.type) return null;
  const Component = REGISTRY[block.type];
  if (!Component) {
    return (
      <div className="py-4 px-4 text-xs opacity-60" data-testid={`block-unknown-${block.type}`}>
        Unbekannter Block-Typ: <code>{block.type}</code>
      </div>
    );
  }
  return (
    <div data-testid={`block-${block.type}`} data-block-id={block.id}>
      <Component data={block.data || {}} />
    </div>
  );
}

export function BlockList({ blocks }) {
  if (!Array.isArray(blocks)) return null;
  const sorted = [...blocks].sort((a, b) => (a.order || 0) - (b.order || 0));
  return (
    <>
      {sorted.map((b) => (
        <BlockRenderer key={b.id} block={b} />
      ))}
    </>
  );
}
